import About from "./pages/About";
import Navbar from "./pages/Navbar";
import {BrowserRouter as Router , Route , Switch} from 'react-router-dom';
import Skills from "./pages/Skills";
import Project from './pages/Project';
import Experience from './pages/Experience';
import Contact from './pages/Contact'
import {AnimatePresence} from 'framer-motion';

 
function App() {
  return (
    <div className="App">
       <Router>
        <Navbar />
          <AnimatePresence>
            <Switch>
              <Route exact path="/">
                <About />
              </Route>
              <Route exact path="/skills">
                <Skills/>
              </Route>
              <Route exact path="/project">
                <Project /> 
              </Route>
              <Route exact path="/experience">
                <Experience />
              </Route>
              <Route exact path="/contact">
                <Contact />
              </Route>
            </Switch>
          </AnimatePresence>
       </Router> 
    </div>
  );
}

export default App;
